<ng-template #selectAll let-selectOptions="selectOptions">
  <mat-option (click)="toggleSelectAll(selectOptions)">
    <mat-pseudo-checkbox class="mat-option-pseudo-checkbox" [state]="getState(selectOptions)">
    </mat-pseudo-checkbox>
    {{ templateOptions.selectAllOption }}
  </mat-option>
</ng-template>

<mat-select
  [id]="id"
  [formControl]="formControl"
  [ngClass]="{'resize':templateOptions.clearable}"
  [formlyAttributes]="field"
  [placeholder]="templateOptions.placeholder"
  [tabindex]="templateOptions.tabindex || 0"
  [compareWith]="templateOptions.compareWith || compareWith"
  [multiple]="templateOptions.multiple"
  (selectionChange)="change($event)"
  [errorStateMatcher]="errorStateMatcher"
  [aria-labelledby]="formField?._labelId"
  [disableOptionCentering]="templateOptions.disableOptionCentering"
>
  <ng-container
    *ngIf="templateOptions.options | formlySelectOptions:field | async as selectOptions"
  >
    <ng-container
      *ngIf="templateOptions.multiple && templateOptions.selectAllOption"
      [ngTemplateOutlet]="selectAll"
      [ngTemplateOutletContext]="{ selectOptions: selectOptions }"
    >
    </ng-container>
    <mat-option
      *ngIf="!templateOptions.required && !templateOptions.multiple && templateOptions.emptyOption"
      [value]="templateOptions.emptyValueIsNull ? null : ''"
      >{{ templateOptions.emptyLabel || 'None' }}</mat-option
    >
    <ng-container *ngFor="let item of selectOptions; trackBy: trackOption">
      <mat-optgroup *ngIf="item.group" [label]="item.label">
        <mat-option
          *ngFor="let child of item.group; trackBy: trackOption"
          [value]="child.value"
          [disabled]="child.disabled"
        >
          {{ child.label }}
        </mat-option>
      </mat-optgroup>
      <mat-option *ngIf="!item.group" [value]="item.value" [disabled]="item.disabled"
        >{{ item.label }}</mat-option
      >
    </ng-container>
  </ng-container>
</mat-select>
<button
  mat-icon-button
  matTooltip="Clear"
  class="clear-select-button clearFilterX"
  *ngIf="templateOptions.clearable"
  snDrawerNavButton
  (click)="clearList()"
  type="button"
>
  <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
</button>
